import { Typography, Stack, Link } from '@mui/material';
import {
  AuthentificationAppleConnect,
  AuthentificationFacebookConnect,
  AuthentificationFormsSignIn,
} from '@scorenco/components';
import {
  AuthentificationState,
  useAmplifyServiceContext,
  useTranslation,
} from '@scorenco/core';

import { T_KEYS } from '@/translations';

import { OrSeparator } from '../components/OrSeparator';

const AuthentificationSignIn = () => {
  const { t } = useTranslation();
  const { changeState } = useAmplifyServiceContext();

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        mb={3}
      >
        <Typography variant="h2" textAlign="left">
          {t(T_KEYS.AUTHENTIFICATION_SIGN_IN_TITLE)}
        </Typography>
        <Link
          onClick={() => {
            changeState({
              authState: AuthentificationState.SelectSport,
            });
          }}
        >
          {t(T_KEYS.AUTHENTIFICATION_SIGN_UP_CTA)}
        </Link>
      </Stack>

      <Stack gap={2} alignItems="stretch" justifyContent="center">
        <AuthentificationAppleConnect sx={{ width: '100%' }}>
          {t(T_KEYS.AUTHENTIFICATION_APPLE_CONNECT)}
        </AuthentificationAppleConnect>
        <AuthentificationFacebookConnect sx={{ width: '100%' }}>
          {t(T_KEYS.AUTHENTIFICATION_FACEBOOK_CONNECT)}
        </AuthentificationFacebookConnect>

        <OrSeparator my={2} mx={4} />

        <AuthentificationFormsSignIn />
      </Stack>
    </>
  );
};

export default AuthentificationSignIn;
